export const ServicesUrls = {
    postHog: 'https://eu.posthog.com',
    consentManager: 'https://cdn.consentmanager.net/delivery/autoblocking/5e11e55321032.js',
    googleTagManagerUrl: 'https://www.googletagmanager.com/gtag/js',
    mindboxUrl: 'https://api.maestra.io/scripts/v1/tracker.js',
    responseWidgetUrl: 'https://static.useresponse.com/public/admitad/sdk/chat-'
};
